<template>
  <el-backtop>
    <i class="el-icon-caret-top" style="font-size: 40px"/>
  </el-backtop>
</template>

<script>
  export default {
    props: {
      visibilityHeight: {
        type: Number,
        default: 500
      },
      right: {
        type: Number,
        default: 90
      },
      bottom: {
        type: Number,
        default: 90
      }
    }
  }

</script>

<style scoped>
.el-backtop {
  width: 60px !important;
  height: 60px !important;
  z-index: 20;
}
</style>
